import { MutableRefObject, useRef } from 'react';

const refMap = new Proxy(
  {},
  {
    set: (target: { [key: string | symbol]: MutableRefObject<any> }, key, value) => {
      if (!target?.[key]) {
        Reflect.set(target, key, value);
        return true;
      }

      return false;
    },
  }
);

function useSharedRef(key: string) {
  if (!key || typeof key !== 'string') {
    throw new Error(
      `Expected key with typeof string, instead got ${key} with a typeof ${typeof key}.`
    );
  }
  const newRef = useRef(null);

  if (refMap[key] === undefined) {
    refMap[key] = newRef;
  }

  return refMap[key];
}

export default useSharedRef;
